// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const CalendarLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 2a1 1 0 0 1 1 1v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7l.005-.176A3 3 0 0 1 6 4h1V3a1 1 0 1 1 2 0v1h6V3a1 1 0 0 1 1-1Zm3 11H5v6l.007.117A1 1 0 0 0 6 20h12a1 1 0 0 0 1-1v-6Zm-3 2a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2Zm-7.293.293a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414ZM7 6H6a1 1 0 0 0-1 1v4h14V7a1 1 0 0 0-1-1h-1v1a1 1 0 1 1-2 0V6H9v1a1 1 0 1 1-2 0V6Z"
            />
        </svg>
    );
};

export const CalendarLineOffset: IconOffset = {
    vertical: 8,
    horizontal: 12,
};

export default React.memo(CalendarLine);
